<template>
  <v-card class="mb-4">
    <v-card-title>来店履歴</v-card-title>

    <v-card-text>
      <v-data-table
        :options="tableOptions"
        :headers="headers"
        :items="visitHistory"
        :loading="isLoading"
        :server-items-length="totalCount"
        :footer-props="{
          itemsPerPageText: '行/ページ:',
          itemsPerPageOptions: [10, 25, 50],
        }"
        no-data-text="来店履歴がありません"
        loading-text="読み込み中..."
        @update:options="handleOptionsUpdate"
      >
        <template #[`item.visitedAt`]="{ item }">
          {{ formatDateTime(item.visitedAt) }}
        </template>

        <template #[`item.customerCount`]="{ item }">
          {{ item.customerCount || 0 }}名
        </template>

        <template #[`item.paidAmount`]="{ item }">
          {{ formatCurrency(item.paidAmount) }}
        </template>

        <template #[`item.total`]="{ item }">
          {{ formatCurrency(item.total) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import { format } from 'date-fns'

export default {
  name: 'CustomerVisitHistory',
  props: {
    visitHistory: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  setup(props, { emit }) {
    const tableOptions = ref({
      page: props.page,
      itemsPerPage: props.perPage,
    })

    const headers = computed(() => [
      {
        text: '日時',
        value: 'visitedAt',
        sortable: false,
        width: '180',
      },
      {
        text: '人数',
        value: 'customerCount',
        sortable: false,
        width: '80',
        align: 'end',
      },
      {
        text: '支払い額',
        value: 'paidAmount',
        sortable: false,
        width: '120',
        align: 'end',
      },
      {
        text: '合計額',
        value: 'total',
        sortable: false,
        width: '120',
        align: 'end',
      },
    ])

    const handleOptionsUpdate = newOptions => {
      tableOptions.value = newOptions
      emit('update:pagination', {
        page: newOptions.page,
        perPage: newOptions.itemsPerPage,
      })
    }

    const formatDateTime = dateString => {
      if (!dateString) return '-'
      try {
        return format(new Date(dateString), 'yyyy/MM/dd HH:mm')
      } catch (e) {
        return dateString
      }
    }

    const formatCurrency = value => {
      if (value === null || value === undefined) return '-'

      return `¥${Number(value).toLocaleString()}`
    }

    return {
      headers,
      tableOptions,
      handleOptionsUpdate,
      formatDateTime,
      formatCurrency,
    }
  },
}
</script>
